import React, { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('promo-banner-dismissed', 'true');
  };
  useEffect(() => {
    // Check if banner was previously dismissed
    const dismissed = localStorage.getItem('promo-banner-dismissed');
    if (dismissed === 'true') {
      setIsVisible(false);
    }
  }, []);
  if (!isVisible) return null;
  return <div className="relative bg-gradient-to-r from-red-600 via-red-600 to-red-700 text-white shadow-lg z-50" data-id="element-1281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3" data-id="element-1282">
        <div className="flex items-center justify-between gap-4" data-id="element-1283">
          {/* Left: Icon + Message */}
          <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-1284">
            <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center" data-id="element-1285">
              <Sparkles size={16} className="text-white" data-id="element-1286" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1287">
              <p className="text-sm sm:text-base font-semibold leading-tight" data-id="element-1288">
                <span className="hidden sm:inline" data-id="element-1289">Limited-Time Offer: </span>
                <span className="text-yellow-300" data-id="element-1290">Get 65% OFF</span>
                <span className="hidden sm:inline" data-id="element-1291">
                  {' '}
                  and unlock premium access now!
                </span>
                <span className="sm:hidden" data-id="element-1292"> premium access!</span>
              </p>
            </div>
          </div>

          {/* Right: CTA + Close */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0" data-id="element-1293">
            <a href="/payment" className="bg-white text-red-600 px-4 sm:px-6 py-2 rounded-lg font-bold text-sm hover:bg-red-50 transition-all shadow-md hover:shadow-lg whitespace-nowrap" data-id="element-1294">
              Upgrade
            </a>
            <button onClick={handleDismiss} className="p-1.5 hover:bg-white/20 rounded-lg transition-colors flex-shrink-0" aria-label="Dismiss banner" data-id="element-1295">
              <X size={18} data-id="element-1296" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}
export default PromoBanner;